export enum ModelType {
  Model = 'Model',
  Basic = 'Basic',
  Sticky = 'Sticky',
}
